import _orderBy from "lodash/orderBy";

export default {
  name: "Home",
  data() {
    return {
      room: {
        name: "New Room",
        nbDices: 1
      },
      isModalOpened: false
    };
  },
  computed: {
    orderedRoom() {
      return _orderBy(Object.values(this.rooms), ["timestamp"], "desc");
    },
    rooms() {
      return this.$store.getters["rooms/getRooms"];
    }
  },
  watch: {
    rooms() {
      this.closeModal();
    }
  },
  mounted() {
    this.$store.dispatch("rooms/fetchRooms");
  },
  methods: {
    openModal() {
      this.isModalOpened = true;
    },
    closeModal() {
      this.isModalOpened = false;
    },
    goToRoom(id) {
      this.$router.push({ name: "room", params: { id: id } });
    },
    createRoom() {
      this.$store.dispatch("rooms/createRoom", this.room);
    }
  }
};
